// MEDIA
export const CREATE_ANNOTATION = 'CREATE_ANNOTATION';
export const UPDATE_ANNOTATION = 'UPDATE_ANNOTATION';
export const DELETE_ANNOTATION = 'DELETE_ANNOTATION';
export const SELECT_ANNOTATION = 'SELECT_ANNOTATION';

export const UNSELECT_ANNOTATION = 'UNSELECT_ANNOTATION';

export const ADD_ANNOTATIONS_TO_REVIEW = 'ADD_ANNOTATIONS_TO_REVIEW';
export const REMOVE_ANNOTATION_FROM_REVIEW = 'REMOVE_ANNOTATION_FROM_REVIEW';
export const CLEAR_ANNOTATIONS_TO_REVIEW = 'CLEAR_ANNOTATIONS_TO_REVIEW';
